import React, { useState, useContext } from "react";
import { CasesContext } from "../CasesContext";
import { useSelector } from "react-redux";

import { Form, Field } from "react-final-form";
import { withRouter } from "react-router-dom";
import DatePickerWrapper from "./DatePicker";
import { caseStatuses } from "../config";

import "./CaseFilter.scss";

const CasesFilter = (props) => {
  const userData = useSelector((state) => state.appReducer.userDataReducer.data);
  const { toggleModal } = props;
  const { activeNav, activeTab, setFilterBy, filterBy } =
    useContext(CasesContext);
  const [showMoreCaseOwner, setshowMoreCaseOwner] = useState();
  const [showMoreStatuses, setshowMoreStatuses] = useState();

  function handleCaseOwnerClick() {
    setshowMoreCaseOwner(!showMoreCaseOwner);
  }

  function handleStausesClick() {
    setshowMoreStatuses(!showMoreStatuses);
  }

  // array of case owners
  const list = userData.Group.Members;
  // get the number of case owners
  const numberOfCaseOwners = showMoreCaseOwner ? list.length : 5;

  // load more case owners with the show more button
  const LoadMoreCaseOwners = () => {
    return (
      <div className="checkbox-list">
        {list.slice(0, numberOfCaseOwners).map((member) => {
          return (
            <div key={member.subjectId}>
              <label>
                <Field
                  name="caseOwners"
                  component="input"
                  type="checkbox"
                  value={member.subjectId}
                />{" "}
                {member.first_name} {member.last_name}
              </label>
              <br />
            </div>
          );
        })}
        {list.length > 5 && (
          <a onClick={() => handleCaseOwnerClick()}>
            {showMoreCaseOwner ? "Show Less" : "Show More"}
          </a>
        )}
      </div>
    );
  };

  const displayStatuses =
    caseStatuses[activeNav.machine_name][activeTab.ui_name] || [];

  const numberOfStatuses = showMoreStatuses ? displayStatuses.length : 10;

  const LoadMoreStatuses = () => {
    return (
      <div className="checkbox-list">
        {displayStatuses.slice(0, numberOfStatuses).map((status, index) => {
          return (
            <div key={index}>
              <label>
                <Field
                  name="statuses"
                  component="input"
                  type="checkbox"
                  value={status}
                />{" "}
                {status}
              </label>
              <br />
            </div>
          );
        })}

        {displayStatuses.length > 10 && (
          <a onClick={() => handleStausesClick()}>
            {showMoreStatuses ? "Show Less" : "Show More"}
          </a>
        )}
      </div>
    );
  };

  /*
   * Pass the values to GraphQL function
   */
  const submitFilterBy = (values) => {
    setFilterBy(values);
    toggleModal();
  };
  const handleClear = () => {
    setFilterBy({});
    toggleModal();
  };
  let searchIdTerm;
  const showCaseOwners =
    Array.isArray(list) &&
    list.length > 0 &&
    userData.GroupRole === "Master";
  const showStatuses =
    Array.isArray(displayStatuses) && displayStatuses.length > 0;
  const showSubmissionDate =
    !["9089", "9141"].includes(activeNav.machine_name) &&
    ["Pending Case Number", "Assigned Case Number", "Historical"].includes(
      activeTab.ui_name
    );

  const showAltSubmissionDateRangeText =
    ["9141"].includes(activeNav.machine_name) &&
    ["Pending Case Number", "Assigned Case Number", "Historical"].includes(
      activeTab.ui_name
    );

  const showHasActiveNotification = [
    "Assigned Case Number",
    "Historical",
    "Appeal",
  ].includes(activeTab.ui_name);

  let showStartEndDates,
    showInitiatedDateRange,
    showAppealDateRange,
    showSubmissionDateRange,
    showDeterminationDate = false;
  let showForeignWorkerNameText = "";

  switch (activeNav.machine_name) {
    case "9142A":
      showStartEndDates = ["Assigned Case Number", "Historical"].includes(
        activeTab.ui_name
      );
      break;
    case "9089":
      showInitiatedDateRange = ["Initiated"].includes(activeTab.ui_name);
      showAppealDateRange = ["Appeal"].includes(activeTab.ui_name);
      showSubmissionDateRange = [
        "Pending Case Number",
        "Assigned Case Number",
        "Historical",
      ].includes(activeTab.ui_name);
      showDeterminationDate = ["Historical"].includes(activeTab.ui_name);
      showForeignWorkerNameText = " Foreign Worker Name,";
      break;
    case "9141":
      showSubmissionDateRange = true;
      break;
    default:
      showStartEndDates = !["9141", "9141C", "9089"].includes(
        activeNav.machine_name
      );
  }

  switch (activeTab.machine_name) {
    case "RegistrationNumber":
      showStartEndDates = false;
  }

  switch (activeTab.machine_name) {
    case "Initiated":
      searchIdTerm = "Application ID";
      break;
    case "Presubmitted":
      searchIdTerm = "Pending Case Number";
      break;
    case "RegistrationNumber":
      searchIdTerm = "Registration Number";
      break;
    default:
      searchIdTerm = "Case Number";
  }

  const caseOwnerBadge = (values) => {
    return values && values.caseOwners && values.caseOwners.length > 0 ? (
      <div className="badge">{values.caseOwners.length}</div>
    ) : null;
  };
  const statusBadge = (values) => {
    return values && values.statuses && values.statuses.length > 0 ? (
      <div className="badge">{values.statuses.length}</div>
    ) : null;
  };
  return (
    <Form
      onSubmit={submitFilterBy}
      initialValues={filterBy}
      render={({ handleSubmit, form, submitting, pristine, values }) => (
        <form onSubmit={handleSubmit}>
          <div className="caseFilter">
            <h2 className="caseFilter_h2_filterby">Filter By</h2>
            <div>
              <p>
                <b>Text</b>
                <br />
                <small>
                  {`Enter a ${searchIdTerm}, Employer Name,
                  ${showForeignWorkerNameText} or
                  Job Title`}
                </small>
                <br />
              </p>

              <div className="usa-search usa-search--small desktop:grid-col-12 tablet:grid-col-12">
                <div role="search" className="cases-search">
                  <Field
                    type="search"
                    name="search"
                    component="input"
                    id="search-cases"
                    className="usa-input"
                    placeholder="Enter a search term"
                  />
                </div>
              </div>
            </div>

            {showCaseOwners ? (
              <>
                <div>
                  <p>
                    <label>
                      <b>Case Owner {caseOwnerBadge(values)}</b>
                    </label>
                    <div>
                      <LoadMoreCaseOwners />
                    </div>
                  </p>
                </div>

                <hr />
              </>
            ) : null}
            {showStatuses && (
              <>
                <div>
                  <p>
                    <label>
                      <b>Status {statusBadge(values)}</b>
                    </label>
                    <div>
                      <LoadMoreStatuses />
                    </div>
                  </p>
                </div>

                <hr />
              </>
            )}
            {showStartEndDates && (
              <div>
                <p>
                  <label>
                    <b>Start Date</b>
                  </label>
                  <Field
                    name="startDate"
                    component={DatePickerWrapper}
                    minDate={null}
                    maxDate={values.endDate || null}
                  />
                </p>

                <p>
                  <label>
                    <b>End Date</b>
                  </label>
                  <Field
                    name="endDate"
                    component={DatePickerWrapper}
                    minDate={values.startDate || null}
                    maxDate={null}
                  />
                </p>
              </div>
            )}
            {showSubmissionDateRange && (
              <div>
                <p>
                  <label>
                    {showAltSubmissionDateRangeText ? (
                      <b>Submission Date From</b>
                    ) : (
                      <b>Submission Start Date</b>
                    )}
                  </label>
                  <Field
                    name="startSubmissionDate"
                    component={DatePickerWrapper}
                    minDate={null}
                    maxDate={values.endSubmissionDate || null}
                  />
                </p>

                <p>
                  <label>
                    {showAltSubmissionDateRangeText ? (
                      <b>Submission Date To</b>
                    ) : (
                      <b>Submission End Date</b>
                    )}
                  </label>
                  <Field
                    name="endSubmissionDate"
                    component={DatePickerWrapper}
                    minDate={values.startSubmissionDate || null}
                    maxDate={null}
                  />
                </p>
              </div>
            )}
            {showInitiatedDateRange && (
              <div>
                <p>
                  <label>
                    <b>Initiated Start Date</b>
                  </label>
                  <Field
                    name="startInitiatedDate"
                    component={DatePickerWrapper}
                    minDate={null}
                    maxDate={values.endInitiatedDate || null}
                  />
                </p>

                <p>
                  <label>
                    <b>Initiated End Date</b>
                  </label>
                  <Field
                    name="endInitiatedDate"
                    component={DatePickerWrapper}
                    minDate={values.startInitiatedDate || null}
                    maxDate={null}
                  />
                </p>
              </div>
            )}
            {showAppealDateRange && (
              <div>
                <p>
                  <label>
                    <b>Appeal Receipt Start Date</b>
                  </label>
                  <Field
                    name="startAppealDate"
                    component={DatePickerWrapper}
                    minDate={null}
                    maxDate={values.endAppealDate || null}
                  />
                </p>

                <p>
                  <label>
                    <b>Appeal Receipt End Date</b>
                  </label>
                  <Field
                    name="endAppealDate"
                    component={DatePickerWrapper}
                    minDate={values.startAppealDate || null}
                    maxDate={null}
                  />
                </p>
              </div>
            )}
            {showHasActiveNotification && (
              <div>
                <p>
                  <label>
                    <b>Notifications</b>
                  </label>
                  <div>
                    <div className="checkbox-list">
                      <label>
                        <Field
                          name="hasActiveNotification"
                          component="input"
                          type="checkbox"
                          value={true}
                        />{" "}
                        Active
                      </label>
                    </div>
                  </div>
                </p>
                <hr />
              </div>
            )}
            {showDeterminationDate && (
              <div>
                <p>
                  <label>
                    <b>Determination Start Date</b>
                  </label>
                  <Field
                    name="startDeterminationDate"
                    component={DatePickerWrapper}
                    minDate={null}
                    maxDate={values.endDeterminationDate || null}
                  />
                </p>

                <p>
                  <label>
                    <b>Determination End Date</b>
                  </label>
                  <Field
                    name="endDeterminationDate"
                    component={DatePickerWrapper}
                    minDate={values.startDeterminationDate || null}
                    maxDate={null}
                  />
                </p>
              </div>
            )}
            {showSubmissionDate && (
              <div>
                <p>
                  <label>
                    <b>Submission Date</b>
                  </label>
                  <Field
                    name="submissionDate"
                    component={DatePickerWrapper}
                    minDate={null}
                    maxDate={new Date()}
                  />
                </p>
              </div>
            )}
          </div>

          <div className="caseFilterButtons">
            <button
              className="caseFilterClear"
              type="button"
              onClick={handleClear}
              // disabled={Object.keys(values).length === 0}
            >
              Clear Filter
            </button>

            <button
              className="caseFilterSubmit"
              type="submit"
              // disabled={Object.keys(values).length === 0}
            >
              Apply
            </button>
          </div>
        </form>
      )}
    />
  );
};

export default CasesFilter;
